<div class="journey-modal-header">
  <h2>Share Journey</h2>
  <button
    mat-flat-button=""
    color="accent"
    class="mat-focus-indicator ml-10 mat-flat-button mat-button-base mat-accent"
    style="float: right"
    (click)="save()"
  >
    <span class="mat-button-wrapper">Share</span
    ><span matripple="" class="mat-ripple mat-button-ripple"></span
    ><span class="mat-button-focus-overlay"></span>
  </button>
</div>
<div class="journey-modal-header form-field w-100">
  <form class="example-form w-100">
    <mat-form-field appearance="outline" class="example-chip-list">
      <mat-label>Username</mat-label>
      <mat-chip-list #chipList aria-label="Fruit selection">
        <mat-chip
          *ngFor="let fruit of fruits"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(fruit)">
          {{fruit.email}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input
          placeholder="Add User..."
          #fruitInput
          [formControl]="fruitCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          >
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
          {{fruit.email}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>
</div>
<!-- <div class="journey-modal-header form-field w-100">
  <form class="example-form w-100">
    <mat-form-field appearance="outline" class="example-full-width">
      <input id="journey" [formControl]="username" placeholder="Username" matInput />
    </mat-form-field>
  </form>
  <button
    mat-flat-button=""
    color="accent"
    class="mat-focus-indicator ml-10 mat-flat-button mat-button-base mat-accent"
    style="float: right"
  >
    <span class="mat-button-wrapper">+</span
    ><span matripple="" class="mat-ripple mat-button-ripple"></span
    ><span class="mat-button-focus-overlay"></span>
  </button>
</div> -->

<section class="example-container share-journey-table" tabindex="0">
  <table mat-table [dataSource]="dataSource" class="w-100" *ngIf="isTableVisible">
    <!-- Email Column -->
    <ng-container matColumnDef="email" sticky>
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>

    <!-- Action Column -->
    <ng-container matColumnDef="action" stickyEnd>
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">Action</th>
      <td mat-cell *matCellDef="let element" >
        <mat-icon style="cursor: pointer;" *ngIf="isOwner(element)" (click)="delete(element)">delete</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</section>
